// On réassigne state mais c'est prévu par redux-toolkit
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import formulaireApi from '@services/formulaireApi';
import carteMembreApi from '@services/carteMembreApi';


import { RootState } from './store';

const sliceName = 'theme';
const DARK_MODE_STORAGE_KEY = 'mcm-dark-mode';

function loadDarkModeFromStorage(): boolean {
  try {
    const stored = localStorage.getItem(DARK_MODE_STORAGE_KEY);
    if (stored === null) {
      return false;
    }
    return stored === 'true';
  } catch {
    return false;
  }
}

export interface ThemeSlice {
  primaryColor?: string;
  secondaryColor?: string;
  darkMode: boolean;
  isAdminZone: boolean;
}

const initialState: ThemeSlice = {
  darkMode: loadDarkModeFromStorage(),
  isAdminZone: false,
};

export const themeSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<{ primaryColor: string; secondaryColor: string; }>) => {
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      try {
        localStorage.setItem(DARK_MODE_STORAGE_KEY, String(state.darkMode));
      } catch { /* localStorage unavailable in tests */ }
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
      try {
        localStorage.setItem(DARK_MODE_STORAGE_KEY, String(state.darkMode));
      } catch { /* localStorage unavailable in tests */ }
    },
    setAdminZone: (state, action: PayloadAction<boolean>) => {
      state.isAdminZone = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      formulaireApi.endpoints.getFormulaireByRoute.matchFulfilled,
      (state, action) => {
        state.primaryColor = action.payload.primaryColor;
        state.secondaryColor = action.payload.secondaryColor;
      });
    builder.addMatcher(
      carteMembreApi.endpoints.getCarteImage.matchFulfilled,
      (state, action) => {
        state.primaryColor = action.payload.primaryColor;
        state.secondaryColor = action.payload.secondaryColor;
      });
  },
});


export const accountSliceName = themeSlice.name;

export const { toggleDarkMode, setDarkMode, setAdminZone } = themeSlice.actions;

export const selectTheme = (state: RootState) => state.theme;
export const selectDarkMode = (state: RootState) => state.theme.darkMode;
export const selectIsAdminZone = (state: RootState) => state.theme.isAdminZone;

export default themeSlice.reducer;

